
<template>
  <div>
    <v-row class="px-3" align="center">
      <v-col cols="6">
        <slot></slot>
        <div class="headline mb-0">Faturas de frete a pagar</div>
      </v-col>
      <v-col cols="6">
        <v-card class="elevation-1 mt-4" style="border-radius: 8px;">
          <v-row justify="space-around" align='center' class="px-2">
            <v-col class="py-2 px-3" cols='3'>
              <v-icon large color="blue-grey darken-3">mdi-currency-usd</v-icon>
            </v-col>
            <v-col class="py-4 px-3" cols='9'>
              <div class="text-h6 font-weight-bold" style="color: #455A64; word-break: normal">Total a Pagar: {{ total_in_currency }}</div>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
      <v-col cols="12" class="d-flex">
        <pay-driver v-on="$listeners" :model="model_type_tabs" :max_value_allowed="open_transactions_max_value" :modality_id="modality_id"></pay-driver>
        <print-open-transactions :type_tabs="type_tabs" class="ml-2"></print-open-transactions>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols=12 class="pt-0">
        <v-data-table :headers="headers" :items="open_transactions"  class="elevation-0" ref="refTable" mobile-breakpoint="1">
          <template v-slot:item.DateExpired="{item}">
            {{ item.DateExpired ? ($moment(item.DateExpired).add(12, 'hour').format('DD/MM/YYYY')) : ($moment(item.expected_delivery).add(12, 'hour').format('DD/MM/YYYY')) }}
          </template>
          <template v-slot:item.nf_num="{item}">
            <span v-if="item.nf_num?.[0]">
              {{ item.nf_num.join(', ') }}
            </span>
          </template>
          <template v-slot:item.items_ships="{item}">
            <div v-for="i in item.items_ships">
              {{ parseFloat(i).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'}) }}
            </div>
          </template>
          
          <template v-slot:item.ammount="{item}">
            {{ (Number(item.ammount) || Number(item.total_shipping_value)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL'}) }}
          </template>
  
          <template v-slot:item.ammount_payed="{item}">
            {{ Number(item.ammount_payed).toLocaleString('pt-BR', {style: 'currency',currency: 'BRL'})}}
          </template>
          <template v-slot:item.ammount_rest="{item}">
            {{((Number(item.ammount) || Number(item.total_shipping_value)) - Number(item.ammount_payed)).toLocaleString('pt-BR', {style:'currency', currency: 'BRL'})}}
          </template>
  
          <template v-slot:item.order_id="{item}">
            {{item.order_id}}
            <v-btn color="rgba(0, 0, 0, 0.0)" v-if="selectedSolution == 'wholesale'" small icon @click="redirectToItemView(item.order_id, 'order')">
              <v-icon small color="primary">mdi-open-in-new</v-icon>
            </v-btn>
          </template>
  
          <template v-slot:item.delivery_id="{item}">
            {{item.delivery_id}}
            <v-btn v-if="selectedSolution == 'retail'" color="rgba(0, 0, 0, 0.0)" small icon @click="redirectToItemView(item.delivery_id, 'delivery')">
              <v-icon small color="primary">mdi-open-in-new</v-icon>
            </v-btn>
          </template>
  
          <template v-slot:no-data>
            <v-alert :value="true" type="success" icon="mdi-alert">
              Não há mais faturas abertas.
            </v-alert>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'DriverOpenTransactions',
  components: {
    PayDriver: () => import('./PayDriver.vue'),
    PrintOpenTransactions: () => import('./PrintOpenTransactions.vue'),
  },
  props:{
    type_tabs:{
      type: Number,
      default: 0,
    },
    selectedSolution: {
      type: String,
      default: null
    },
    modality_id: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      search: null,
    }
  },
  computed: {  
    model_type_tabs(){
      return "Driver"
    },
    headers(){
      if( this.selectedSolution == 'wholesale'){
        return [
          { text: 'Data', align: 'center', value: 'DateExpired' },
          { text: 'Valor', align: 'center', value: 'ammount' },
          { text: 'Valor pago', align: 'center', value: 'ammount_payed' },
          { text: 'Valor a pagar', align: 'center', value: 'ammount_rest'},
          { text: 'Pedido', align: 'center', value: 'order_id' },
          { text: 'NF', align: 'center', value: 'nf_num' },
          { text: 'Comentário', align: 'center', value: 'comment', width: '350' },
          { text: 'Marca', align: 'center', value: 'brand_name' },
        ]
      }else{
        return [
          { text: 'Data', align: 'center', value: 'DateExpired' },
          { text: 'Frete unid.', align: 'center', value: 'items_ships' },
          { text: 'Unidades', align: 'center', value: 'total_units' },
          { text: 'Valor total', align: 'center', value: 'ammount' },
          { text: 'Valor a pagar', align: 'center', value: 'ammount_rest'},
          { text: 'Valor pago', align: 'center', value: 'ammount_payed' },
          { text: 'Pedido', align: 'center', value: 'order_id' },
          { text: 'Entrega', align: 'center', value: 'delivery_id' },
        ]
      }
    },
    total_in_currency() {
      if (this.open_transactions) {
        var all_data = this.search ? this.$refs.refTable._data.internalCurrentItems : this.open_transactions
        var to_pay = all_data ? all_data.reduce((acc, one) => acc + ((Number(one.ammount) || Number(one.total_shipping_value)) - Number(one.ammount_payed)), 0) : 0

        return Number(to_pay).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
      }
    },
    open_transactions() {
      if (this.driver && (this.driver.open_incomes || this.driver.data)) {
        return this.driver.open_incomes || this.driver.data.attributes.open_incomes
      }
      return []
    },
    open_transactions_max_value() {
      if (this.driver && this.open_transactions) {
        let val = this.open_transactions.reduce((acc, one) => acc + ((Number(one.ammount) || Number(one.total_shipping_value)) - Number(one.ammount_payed)), 0)
        val = Math.round(val * 100) / 100
        return { val, val_string: Number(val).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }
      }
      return {}
    },
    ...mapState({
      driver: state => state.Driver.oneDriver,
    })
  },
  methods: {
    redirectToItemView(id, kind){
      const links = {
        order: {
          production: 'https://grandes_cargas.webcimentao.com.br/',
          development: 'http://localhost:3000/',
          qa: 'https://grandes_cargas_qa2.webcimentao.com.br/',
        },
        delivery:{
          production: 'https://galpoes.webcimentao.com.br/',
          development: 'http://localhost:8080/',
          qa: 'https://galpoes-qa.webcimentao.com.br/',
        }
      }
      let url = links[kind][process.env.NODE_ENV.toLowerCase()]

      if(this.selectedSolution == 'retail'){
        url += `${kind}/${id}`
      }else if(this.selectedSolution == 'wholesale'){
        url += `concluded/order/${id}`
      }

      window.open(url, '_blank');
    },
  },

}
</script>